/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DropTwitchClipResponse
 */
export interface DropTwitchClipResponse {
    /**
     * 
     * @type {string}
     * @memberof DropTwitchClipResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DropTwitchClipResponse
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof DropTwitchClipResponse
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof DropTwitchClipResponse
     */
    embedUrl: string;
    /**
     * 
     * @type {string}
     * @memberof DropTwitchClipResponse
     */
    thumbnailUrl: string;
    /**
     * 
     * @type {string}
     * @memberof DropTwitchClipResponse
     */
    createdAt: string;
    /**
     * 
     * @type {number}
     * @memberof DropTwitchClipResponse
     */
    durationSeconds: number;
    /**
     * 
     * @type {number}
     * @memberof DropTwitchClipResponse
     */
    viewCount: number;
    /**
     * 
     * @type {string}
     * @memberof DropTwitchClipResponse
     */
    creatorName: string;
    /**
     * 
     * @type {string}
     * @memberof DropTwitchClipResponse
     */
    gameId?: string;
}

/**
 * Check if a given object implements the DropTwitchClipResponse interface.
 */
export function instanceOfDropTwitchClipResponse(value: object): value is DropTwitchClipResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('embedUrl' in value) || value['embedUrl'] === undefined) return false;
    if (!('thumbnailUrl' in value) || value['thumbnailUrl'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('durationSeconds' in value) || value['durationSeconds'] === undefined) return false;
    if (!('viewCount' in value) || value['viewCount'] === undefined) return false;
    if (!('creatorName' in value) || value['creatorName'] === undefined) return false;
    return true;
}

export function DropTwitchClipResponseFromJSON(json: any): DropTwitchClipResponse {
    return DropTwitchClipResponseFromJSONTyped(json, false);
}

export function DropTwitchClipResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropTwitchClipResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'url': json['url'],
        'embedUrl': json['embedUrl'],
        'thumbnailUrl': json['thumbnailUrl'],
        'createdAt': json['createdAt'],
        'durationSeconds': json['durationSeconds'],
        'viewCount': json['viewCount'],
        'creatorName': json['creatorName'],
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
    };
}

export function DropTwitchClipResponseToJSON(json: any): DropTwitchClipResponse {
    return DropTwitchClipResponseToJSONTyped(json, false);
}

export function DropTwitchClipResponseToJSONTyped(value?: DropTwitchClipResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'url': value['url'],
        'embedUrl': value['embedUrl'],
        'thumbnailUrl': value['thumbnailUrl'],
        'createdAt': value['createdAt'],
        'durationSeconds': value['durationSeconds'],
        'viewCount': value['viewCount'],
        'creatorName': value['creatorName'],
        'gameId': value['gameId'],
    };
}

